import { inject } from 'inversify';
import { HttpClientType } from '@core/http';
import type { IHttpClient } from '@core/http';
import { IRepo, IRepoResponse } from '@core/repo';
import { appendToFormData, urlMaker } from '@core/utils';
import { bind } from '@infra/container';

import { CreateUnknownDeclarationErrorMapper, CreateUnknownDeclarationMapper } from '../mappers';
import { CreateUnknownDeclarationDto } from '../dto';

export type ICreateUnknownDeclarationRepoResponse = IRepoResponse<200> | IRepoResponse<422, object> | IRepoResponse<400 | 500, string>;

export type ICreateUnknownDeclarationRepo = IRepo<[CreateUnknownDeclarationDto, string | number | undefined], ICreateUnknownDeclarationRepoResponse>;

export const CreateUnknownDeclarationRepoType = Symbol.for('CreateUnknownDeclarationRepo');

@bind(CreateUnknownDeclarationRepoType)
export class CreateUnknownDeclarationRepo implements ICreateUnknownDeclarationRepo {
  constructor(@inject(HttpClientType) private readonly httpClient: IHttpClient) {}

  async execute(dto: CreateUnknownDeclarationDto, id?: string | number) {
    try {
      const body = new FormData();
      const mappedBody = CreateUnknownDeclarationMapper.toPersistence(dto);

      appendToFormData(mappedBody, body);

      const url = id ? urlMaker('/api/admin/conflicted_declaration/edit') : urlMaker('/api/admin/conflicted_declaration/create');

      const result = await this.httpClient.post({ url, body });

      if (result.status === 200) {
        return {
          status: 200 as 200,
          response: null,
        };
      } else if (result.status === 400) {
        const errors = CreateUnknownDeclarationErrorMapper.toDomain(result.data.errors);

        return {
          status: 422 as 422,
          response: errors,
        };
      } else {
        return {
          status: 400 as 400,
          response: 'Məlumatlar əldə edilə bilmədi',
        };
      }
    } catch (e) {
      return {
        status: 500 as 500,
        response: 'Şəbəkə ilə əlaqə qurula bilmədi.',
      };
    }
  }
}
